<div class="w-embed w-iframe">
  <!--  Google Tag Manager (noscript)  -->
  
</div>
<app-auth-navbar></app-auth-navbar>
<div class="w-100 justify-content-center show-ios" *ngIf="isIosFirst">
  <div class="position-fixed px-5 py-3 bg-light rounded mb-2 w-85" style="bottom:0;z-index: 999">
    <div class="text-right">
        <i class="fas fa-times" (click)="popupClose()"></i>
    </div>
    <div>
      Tap on <i class="fas fa-sign-out-alt rotate-90"></i> then
      <span class="font-weight-bold">'Add to Home Screen'</span>
      from browser menu to install N2Xpress on your mobile device.
    </div>
  </div>
</div>
<div class="hero" style="margin-top: 72px;">
  <div class="d-flex justify-content-left flex-wrap position-absolute" style="top:100px;left:1%" *ngIf="screen_width>996 && offer?.status">
    <div class="col-9 col-md-8 px-3 text-center py-1 offer" style="background-color: #A0BF81;" [innerHTML]="offer.subject">
    </div>
    <div class="col-6 px-2 text-center mt-2 py-2 offer" style="background-color: #266DD3;" [innerHTML]="offer.message">
    </div>
  </div>
  <div class="container w-container ">
    <div class="hero-right-pane custom-hero-pane">
      <div class="calculator-panel">
        <div class="calculator-header">
          <!-- <h1 class="hero-heading">Save more with <br>online money transfers</h1> -->
          <h1 class="hero-heading" style="font-size: 28px;">Online&nbsp;money&nbsp;transfers made easy.<span class="text-success"> Start here.</span></h1>
        </div>
        <div class="form-block w-form">
          <form id="email-form" name="email-form" data-name="Email Form" redirect="https://app.n2xpress.ca/login" data-redirect="https://app.n2xpress.ca/login" class="form">
            <div class="div-block-13">
              <input [(ngModel)]="amount" (keyup)="onAmountChange($event.target.value)" type="number" style="background:none!important; border:none;" class="text-field w-input m-0 p-3" def="10" autofocus="true" maxlength="256" name="Send" data-name="Send" placeholder="You send" id="currency-send" required="">
              <div data-hover="" data-delay="0" class="w-dropdown">
                <!-- <select (change)="onSourceChange($event.target.value)" class="bg-alice color-blue" style="height:50px">
                  <option value="usd">
                    <div class="text-block-10">USA</div>
                  </option>
                  <option value="cad">
                    <div class="text-block-10">Canada</div>
                  </option>
                  
                </select> -->
                <div class="dropdown  color-blue radiusr-5" style="height:50px" id="sourceDrop"> 
                  <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                    <!-- Country -->
                    {{ countryName }} <img [src]="'assets/images/' + source + '.png'" class="ml-1" width="22" height="22">
                    <!-- <i class="fas fa-angle-down pl-2"></i> -->
                  </button> 
                  
                  <!-- <div class="dropdown-content w-100"> 
                    <a class="d-flex justify-content-between align-items-center" (click)="onSourceChange('cad','Canada')"> 
                      Canada
                      <img alt="CAD" src="assets/images/cad.png" class="ml-1" width="20" height="20">
                    </a> 
                    
                    <a class="d-flex justify-content-between align-items-center" (click)="onSourceChange('usd','USA')"> 
                      USA
                      <img alt="USA" src= "assets/images/usd.png" class="ml-1" width="20" height="20"> 
                    </a> 
                    
                  </div>  -->
                </div>
                
              </div>
            </div>
            <div class="rate-panel">
              <!-- <div class="div-block-15"></div> -->
              <div class="div-block-16 py-3 pl-3 w-100 ">
                <div class="div-block-17 py-2">
                  <div>
                    <div id="currency-fees" class="fee-figure">{{transactionFees}}</div>
                  </div>
                  <div class="rate-currency">
                    <div id="fees-currency" class="rate-currency-text">{{source.toUpperCase()}}</div>
                  </div>
                  <div class="fee-explainer-text">
                    <div class="explainer-text pl-3">Total fees</div>
                  </div>
                </div>
                <div class="div-block-18 py-2">
                  <div class="rate-figure">
                    <div id="currency-rate" class="text-block-12">{{conversionRate}}</div>
                  </div>
                  <div class="rate-currency">
                    <div id="exchange-currency" class="rate-currency-text">{{destination_currency.toUpperCase()}}</div>
                  </div>
                  <div class="rate-explainer">
                    <div class="explainer-text">Your exchange rate</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="div-block-13-copy">
              <input [(ngModel)]="convertedAmount" readonly type="number"  style="background:none!important; border:none;" class="text-field w-input m-0 p-3" maxlength="256" name="Receive" data-name="Receive" placeholder="They receive" id="currency-receive">
              <div data-hover="" data-delay="0" class="w-dropdown">
                <div class="dropdown color-blue radiusr-5" style="height:50px" (click)="common.showDropdown('destDrop')" id="destDrop"> 
                  <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                    <!-- Country -->
                    {{ destinationCountryName }} <img [src]="'assets/images/' + destination_currency + '.png'" class="ml-1" width="22" height="22">
                    <i class="fas fa-angle-down pl-2"></i>
                  </button> 
                  
                  <div class="dropdown-content w-100"> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Austria', 15)"> 
                      Austria
                      <img alt="NGN" src="assets/images/austria.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Belgium', 22)"> 
                      Belgium
                      <img alt="NGN" src="assets/images/belgium.png" class="ml-1" width="20" height="20">
                    </a>
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Benin', 24)"> 
                      Benin
                      <img alt="BENIN" src="assets/images/benin.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Burkina Faso', 35)"> 
                      Burkina Faso
                      <img alt="NGN" src="assets/images/burkinafaso.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xaf','Cameroon', 38)"> 
                      Cameroon
                      <img alt="NGN" src="assets/images/xaf.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('cny','China', 45)"> 
                      China
                      <img alt="NGN" src="assets/images/cny.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xaf','Congo', 50)"> 
                      Congo
                      <img alt="NGN" src="assets/images/congo.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Cyprus', 57)"> 
                      Cyprus
                      <img alt="NGN" src="assets/images/cyprus.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Ivory Coast', 54)"> 
                      Ivory Coast
                      <img alt="NGN" src="assets/images/ivorycoast.png" class="ml-1" width="20" height="20">
                    </a>
                    
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Estonia', 69)"> 
                      Estonia
                      <img alt="NGN" src="assets/images/estonia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Finland', 74)"> 
                      Finland 
                      <img alt="NGN" src="assets/images/finland.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','France', 75)"> 
                      France 
                      <img alt="NGN" src="assets/images/france.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Germany', 82)"> 
                      Germany
                      <img alt="NGN" src="assets/images/germany.png" class="ml-1" width="20" height="20">
                    </a>
                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ghs','Ghana', 83)"> 
                      Ghana
                      <img alt="GHS" src="assets/images/ghs.png" class="ml-1" width="20" height="20">
                    </a> 
                    
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Greece', 85)"> 
                      Greece
                      <img alt="NGN" src="assets/images/greece.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Guinea-Bissau', 93)"> 
                      Guinea-Bissau
                      <img alt="NGN" src="assets/images/guineabissau.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                    </a>
                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('inr','India', 101)"> 
                      India
                      <img alt="INR" src="assets/images/inr.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('idr','Indonesia', 102)"> 
                      Indonesia
                      <img alt="NGN" src="assets/images/idr.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Ireland', 105)"> 
                      Ireland
                      <img alt="NGN" src="assets/images/ireland.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Italy', 107)"> 
                      Italy
                      <img alt="NGN" src="assets/images/italy.png" class="ml-1" width="20" height="20">
                    </a>
                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('kes','Kenya', 113)"> 
                      Kenya
                      <img alt="KES" src="assets/images/kes.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Latvia', 120)"> 
                      Latvia
                      <img alt="NGN" src="assets/images/latvia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Lithuania', 126)"> 
                      Lithuania
                      <img alt="NGN" src="assets/images/lithuania.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Luxembourg', 127)"> 
                      Luxembourg
                      <img alt="NGN" src="assets/images/luxembourg.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Mali', 134)"> 
                      Mali
                      <img alt="NGN" src="assets/images/mali.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Malta', 135)"> 
                      Malta
                      <img alt="NGN" src="assets/images/malta.png" class="ml-1" width="20" height="20">
                    </a>
                    
                    
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Monaco', 145)"> 
                      Monaco
                      <img alt="NGN" src="assets/images/monaco.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Netherlands', 156)"> 
                      Netherlands
                      <img alt="NGN" src="assets/images/netherlands.png" class="ml-1" width="20" height="20">
                    </a>
                   
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Niger', 160)"> 
                      Niger
                      <img alt="NGN" src="assets/images/niger.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ngn','Nigeria', 161)"> 
                      Nigeria
                      <img alt="NGN" src="assets/images/ngn.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('php','Philippines', 174)"> 
                      Philippines
                      <img alt="PHP" src="assets/images/php.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Portugal', 177)"> 
                      Portugal
                      <img alt="NGN" src="assets/images/portugal.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('rwf','Rwanda', 183)"> 
                      Rwanda
                      <img alt="NGN" src="assets/images/spain.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','San Marino', 192)"> 
                      San Marino
                      <img alt="NGN" src="assets/images/sanMarino.png" class="ml-1" width="20" height="20">
                    </a>
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Senegal', 195)"> 
                      Senegal
                      <img alt="XOF" src="assets/images/xof.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('sgd','Singapore', 199)"> 
                      Singapore
                      <img alt="NGN" src="assets/images/sgd.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Slovakia', 200)"> 
                      Slovakia
                      <img alt="NGN" src="assets/images/slovakia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Slovenia', 201)"> 
                      Slovenia
                      <img alt="NGN" src="assets/images/slovenia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('zar','South Africa', 204)"> 
                      South Africa
                      <img alt="ZAR" src="assets/images/zar.png" class="ml-1" width="20" height="20">
                    </a> 
                    
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Spain', 207)"> 
                      Spain
                      <img alt="NGN" src="assets/images/spain.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Togo', 220)"> 
                      Togo
                      <img alt="NGN" src="assets/images/togo.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ugx','Uganda', 229)"> 
                      Uganda
                      <img alt="NGN" src="assets/images/ugx.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('gbp','232')"> 
                      United Kingdom
                      <img alt="NGN" src="assets/images/gbp.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('vnd','Vietnam', 240)"> 
                      Vietnam
                      <img alt="NGN" src="assets/images/vnd.png" class="ml-1" width="20" height="20">
                    </a> 
                  </div> 
                </div>
                
              </div>
            </div>
          </form>
          <div class="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
        <a id="send-money-button" style="background:#266DD3;" routerLink="/dashboard" class="calculator-button w-button rasputin">Send money now <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span></a>
        <small *ngIf="!isIos" class="text-center mt-3 text10 grey-text">Also available on:</small>
        <div *ngIf="!isIos" class="d-flex justify-content-center">
        <a target="blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"> 
          <img  src="assets/images/google-play.png" class="playStore-img  " alt="">
        </a>
        <!-- <p-dialog header="" [closable]="false" [(visible)]="common.visibleIos" [style]="common.respwidth" [modal]="true">
          <h1 class="text-center blue">iOS app coming soon</h1>
          <ng-template pTemplate="footer">
            <p-button icon="pi pi-check" (click)="visibleIos=false" label="Ok" styleClass="p-button-text"></p-button>
            </ng-template>
        </p-dialog> -->
        <a class="cursor-pointer" href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank">
          <img  src="assets/images/apple_store.png" class="appleStore-img  m-1" alt="">
        </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="" *ngIf="!(screen_width>996) && offer?.status">
  <div class="d-flex justify-content-center flex-wrap">
    <div class="col-11 px-3 text-center py-2 offer" style="background-color: #A0BF81;color:white" [innerHTML]="offer.subject">
    </div>
    <div class="col-8 px-3 text-center mt-2 py-2 offer" style="background-color: #266DD3;color:white" [innerHTML]="offer.message">
    </div>
  </div>
</div>

<div class="py-3">
  
  <div class="container-2 w-container py-5" >
    
    <div class="col-12 col-md-6 d-flex align-items-center">
      <img src="../../assets/images/n2bg-1.png" alt="" class="w-100">
    </div>
    <div class="col-12 col-md-6">
      <div class="d-flex flex-column align-items-center">
        <img src="../../assets/images/n2xgo.png" alt="" class="w-50">
        <span style="background-color: #a1c181; font-size: 24px; font-weight: 600 !important;" class="p-2 my-2 w-75 text-center text-white">
          TAP.
          <span class="blue">CLICK.</span>
          SCAN.
          <span class="blue">PAY.</span>
        </span>
        <span class="text-center blue">
          Now with N2Xpress, you can send money overseas or pay global bills in-person at qualifying locations near you including Mobile Gas, MacEwen, Hasty Market, Canadian Tire, PharmaChoice, and many more!  
        </span>
        <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto rasputin">
          Pay in-person now
          <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
        </a>
      </div>
    </div>
    
  </div>
</div>
<div class="py-3">
  
  <div class="container-2 w-container py-5" >
    
    <div class="col-12 col-md-7 d-flex align-items-center">
      <div class="d-flex flex-column align-items-center ">
        <img src="../../assets/images/n2go-1.png" alt="" class="w-100">
        <span>
          <ul style="list-style-type: disc !important;">
            <li>Sign up or log in</li>
            <li>
              Start your transaction online for 
              <span class="blue">money transfer</span>
            </li>
            <li>
              Pay for the transfer with cash or debit card in-person at qualifying location near you
            </li>
          </ul>
        </span>
        <a id="send-money-button" style="background:#a1c181;border-radius: 0;" routerLink="/register" class="col-10 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto rasputin">
          Send money now!
          <span><img class="ml-2" width="18px" src="assets/images_new/logo_white.png" alt=""></span>
        </a>
      </div>
    </div>
    <div class="col-12 col-md-5 d-flex align-items-center">
      <img src="../../assets/images/n2bg-2.png" alt="" class="w-100">
    </div>
    
    
  </div>
</div>
<div class="py-3">
  
  <div class="container-2 w-container py-5" >
    
    <div class="col-12 col-md-7 d-flex align-items-center">
      <div class="d-flex flex-column align-items-center ">
        <img src="../../assets/images/n2go-2.png" alt="" class="w-100">
        <span>
          <ul style="list-style-type: disc !important;">
            <li>Sign up or log in</li>
            <li>
              Start your transaction online for 
              <span class="green-royal">bill pay</span>
            </li>
            <li>
              Pay for the transfer with cash or debit card in-person at qualifying location near you including Canada Post
            </li>
          </ul>
        </span>
        <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto rasputin">
          Pay bills now!
          <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
        </a>
      </div>
    </div>
    <div class="col-12 col-md-5 d-flex align-items-center">
      <img src="../../assets/images/n2bg-3.png" alt="" class="w-100">
    </div>
    
    
  </div>
</div>
<div class="container-fluid flags-custom pb-5 pt-5 text-center ">
  <img alt="Send money with N2Xpress" src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0 my-2">
  <div class="currency-header py-2 mb-0">
    <div class="section-header-text new-flag-section" style="color:#2371D3">
      Partner Locations
    </div>
  </div>
  <app-custom-locations></app-custom-locations>
</div>
<div class="py-1 ">
  <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto rasputin">
    Sign up 
    <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
  </a>
</div>
<div class="container-fluid flags-custom pb-5 pt-5 text-center ">
  <img alt="Send money with N2Xpress" src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0 my-2">
  <div class="text-center">
    
    <div class="currency-header py-2 mb-0">
      <div class="section-header-text new-flag-section" style="color:#2371D3">
          A better way to send <br />
          money internationally
      </div>
    </div>
    <div class="custom-currency-intro text-center">
      <div class="text-center new-flag-section my-2">
        We support popular currencies for sending money from Canada and the United States of America. 

        <br></div>
      </div>
      <div class="row mt-5 mx-0 justify-content-center">
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img alt="SOUTH AFRICA RAND" src="assets/images/sa-flag.PNG" alt="" class="cursor-pointer" routerLink="/cad-to-zar">
          <div class="row justify-content-center">
            <p class="country-names text-center country-sa pt-1 cursor-pointer px-0" routerLink="/cad-to-zar">South Africa Rand</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">ZAR</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section mt-3 " >
          <img alt="NIGERIA" src="assets/images/nigeria-flag.PNG" alt="Nigeria" class="cursor-pointer" routerLink="/cad-to-ngn">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0" routerLink="/cad-to-ngn">Nigerian Naira</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">NGN</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img alt="PHILIPPINE" src="assets/images/philippine-flag.PNG" alt="Philippine" class="cursor-pointer" routerLink="/cad-to-php">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0" routerLink="/cad-to-php">Philippine Peso</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">PHP</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img alt="KENYA" src="assets/images/kenya-flag.PNG" alt="Kenya" class="cursor-pointer" routerLink="/cad-to-kes">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0" routerLink="/cad-to-kes">Kenyan Shilling</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">KES</small>
          </div>
        </div>
        
      <!-- </div> -->
      <!-- <div class="row second-row-flags mx-0 justify-content-center"> -->
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img alt="INDIA" src="assets/images/india-flag.PNG" alt="India" class="cursor-pointer" routerLink="/cad-to-inr">
          <div class="row justify-content-center">
            <p class="country-names text-center country-india pt-1 cursor-pointer px-0" routerLink="/cad-to-inr">Indian Rupee</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">INR</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img alt="SENEGAL" src="assets/images/xof-flag.png" alt="" class="cursor-pointer" routerLink="/cad-to-xof">
          <div class="row justify-content-center">
            <p class="country-names text-center country-senegal pt-1 w-100 cursor-pointer px-0" routerLink="/cad-to-xof">West African CFA Franc</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">CFA</small>
          </div>
        </div> 
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img alt="GHANA" src="assets/images/ghana-flag.png" alt="Ghana" class="cursor-pointer" routerLink="/cad-to-ghs">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0" routerLink="/cad-to-ghs">Ghanaian Cedi</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">GHS</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/vietnam-flag.png" alt="Vietnam" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">Vietnamese Dong</p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">VND</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/indonesia-flag.png" alt="Indonesia" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">Indonesian Rupiah
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">IDR</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/singapore-flag.png" alt="Singapore" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">Singapore Dollar
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">SGD</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/china-flag.png" alt="China" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">Chinese Yen
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">CNY</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/uganda-flag.png" alt="uganda" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">Ugandan Shilling
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">UGX</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/rwanda-flag.png" alt="rwanda" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">Rwandan Franc
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">RWF</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/cameroon-flag.png" alt="cameroon" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names country-senegal pt-1 text-center w-100 cursor-pointer px-0">Central African CFA franc
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">XAF</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/congo-flag.png" alt="congo" class="cursor-pointer">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">Congolese Franc
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">XAF</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/eur.png" alt="SEPA" class="cursor-pointer rounded">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">SEPA countries
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">EUR</small>
          </div>
        </div>
        <div class="col-md-3 col-6 flags-section  mt-3 " >
          <img src="assets/images/uk-flag.png" alt="United Kingdom" class="cursor-pointer rounded">
          <div class="row justify-content-center">
            <p class="country-names text-center country-ghana pt-1 cursor-pointer px-0">British Pound
            </p>
          </div>
          <div class="row justify-content-center">
            <small class="country-currency px-0 text-center">GBP</small>
          </div>
        </div>
        <!-- <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-xof">
          <img src="assets/images/benin-flag.png" alt="Benin">
          <div class="row">
            <p class="country-names country-benin pt-1">Benin</p>
          </div>
          <div class="row">
            <small class="country-currency">CFA</small>
          </div>
        </div>
        
        
         -->
         <!-- <div class="col-md-3 col-12 flags-section  mt-3" >
          <img src="assets/images/mexico-flag.png" alt="Mexico" routerLink="/cad-to-xof" class="cursor-pointer">
          <div class="row">
            <p class="country-names country-benin pt-1 px-0 text-center w-100 cursor-pointer" routerLink="/cad-to-xof">Mexican Peso</p>
          </div>
          <div class="row">
            <small class="country-currency">MXN</small>
          </div>
        </div> -->

        

      </div>
      
    </div>
</div>

<div class=" ">
  <a id="send-money-button" style="background:#266DD3; border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 my-5 text-white calculator-button d-block mx-auto rasputin">
    Send money now 
    <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
  </a>
</div>
<div class="do-more-section pt-5 pb-2 ">
  
  <div class="container-2 w-container flex-column-reverse flex-md-row">
    
    <div class="div-block-8">
      <div class="do-more-left">
        <div class="do-more-header">
          <h1 class="heading">N2Xpress also helps you pay bills internationally.</h1>
        </div>
        <div class="do-more-subjeading">
          <div class="benefits">Showing your loved ones you care is now easier than ever with N2Xpress. Use our services to pay bills internationally to help out with daily expenses and life’s other necessities.</div>
        </div>
        <div class="do-more-benefits">
          <div class="benefit-child">
            <div class="benefit-child-heading">Utilities</div>
            <div class="benefit-child-copy"> Cover various utilities such as electricity, water and gas bills.<br></div>
          </div>
          <div class="benefit-child">
            <div class="benefit-child-heading">Airtime</div>
            <div class="benefit-child-copy">Top up airtime from abroad.<br></div>
          </div>
          <div class="benefit-child">
            <div class="benefit-child-heading">Tuition</div>
            <div class="benefit-child-copy">Invest in the future of your loved ones.<br></div>
          </div>
          <div class="benefit-child">
            <div class="benefit-child-heading">Tax</div>
            <div class="benefit-child-copy">Help pay off annual tax bills<br></div>
          </div>
          <div class="benefit-child">
            <div class="benefit-child-heading">Home delivery</div>
            <div class="benefit-child-copy">Pay for groceries or other goods, delivered right to your loved ones’ doorsteps<br></div>
          </div>
        </div>
      </div>
    </div>
    <div class="div-block-7">
      <div data-w-id="39ed0bee-a3b6-8b83-ee4f-3e207184d211" class="do-more-right"><img src="assets/images_new/homepage_2.png" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="do-more-user"><img src="assets/images_new/homepage_bg_2.svg" loading="lazy" alt="" class="do-more-user-pattern"></div>
    </div>
  </div>
</div>

<div class=" container-fluid methods-section py-5 text-center ">
  <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="methods-chop mb-0">
  <div class="methods-container w-container">
    <div class="methods-header">
      <div class="section-header-text testimonial">
        Send and receive <br />
        the way you like</div>
    </div>
    <div class="div-block-3 flex-column-reverse flex-md-row">
      <div class="col-8 col-md-4">
        <img src="assets/images_new/homepage_3.png" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="method-user">
        <img src="assets/images_new/homepage_bg_3.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="method-user-pattern">
      </div>
      <div class="methods-left new-flag-section">
        <div class="text-block-9 new-flag-section text-left">Conveniently send and receive money internationally with a variety of options to fit your needs</div>
        <div class="methods-content flex-column flex-md-row justify-content-center">
          <div class="methods-send text-left">
            <div class="method-heading">Send options:</div>
            <div class="method-item">Debit or credit card</div>
            <div class="method-item">Bank transfer</div>
            <div class="method-item"></div>
            <div class="method-item"></div>
          </div>
          <div class="methods-receive text-left">
            <div class="method-heading">Receive options: </div>
            <div class="method-item">Bank account</div>
            <div class="method-item">Mobile airtime</div>
            <div class="method-item">Bill payment</div>
            <!-- <div class="method-item">Mobile wallet</div> -->
          </div>
        </div>
        
      </div>
      
    </div>
  </div>
</div>
<div class="text-center  py-5">
  <small *ngIf="!isIos" class="text-left mt-3 grey-text" style="font-size: 12px;">Also available on:</small>
  <div *ngIf="!isIos" class="text-left text-center">
    <a target="blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"> 
      <img  src="assets/images/google-play.png" class="playStore-img-large " alt="">
    </a>
    <a class="cursor-pointer"  href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank"> 
      <img  src="assets/images/apple_store.png" class="appleStore-img-large  m-1" alt="">
    </a>
  </div>
</div>
<div class="new-section">
  <div class="benefits-heading-section pt-5 text-center">
    <img src="assets/images_new/logo_white.png" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="benefits-chop mb-0">
    <div class="w-container">
      <div class="testimonial-header">
        <div class="benefits-heading text-white">A better way to send <br /> money internationally</div>
      </div>
    </div>
  </div>
  <div class="benefits-section py-0">
    <div class="container-13 w-container d-flex" style="min-height:400px">
      <div class="benefits-body-home pt-0 pt-md-5">
        <div class="benefit-box-home text-center text-md-left">
          <div class="benefit-header">
            <div class="fast">Secure</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">We use the highest security and compliance processes to make sure your money and personal details are always safe.
            </div>
          </div>
        </div>
        <div class="benefit-box-home text-center text-md-left">
          <div class="benefit-header">
            <div class="low-cost">Fast</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Create an account and start sending money within minutes. The money is sent instantly to international destinations to your desired recipient.We also offer same day payments on select currencies and 24/7 customer support.
            </div>
          </div>
        </div>
        <div class="benefit-box-home text-center text-md-left">
          <div class="benefit-header">
            <div class="secure">Competitive fees</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Sending money doesn’t have to cost a fortune. That’s why N2Xpress offers competitive rates so that you always get the most out of every transaction. Save more with our great rates.<br></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="testimonial-section">
  <div class="instruction-header mb-0">
    <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
    <div class="instruction-container w-container">
      <div class="section-header-text instructions" style="color:#2371D3">Easy online <br /> money transfers</div>
    </div>
    
  </div>
  <div class="benefits-section-bills benefits-section-bills-home">
    <div class="benefits-container w-container">
      <div class="benefit-2">
        <div class="benefit-header text-center text-md-left">
          <div class="text-block-23">1</div>
        </div>
        <div class="benefit-text">
          <div class="text-block-22 text-center text-md-left">Create your free account</div>
          <div class="row">
            <p class="sm-14 secondary-text intro-copy-text text-center text-md-left">
              Already have an account? 
              <span style="color:#2371D3"><a [routerLink]="['/signin']">Sign in</a></span> 
              to start your transaction. <br />
              <!-- <button [routerLink]="['/signin']"   class="btn primary-btn nav-register mx-0 my-2 text-white">Sign in</button> -->
            </p>
            
          </div>
        </div>
      </div>
      <div class="benefit-1">
        <div class="benefit-header text-center text-md-left">
          <div class="text-block-23">2</div>
        </div>
        <div class="benefit-text">
          <div class="text-block-22 text-center text-md-left">Choose currency</div>
          <div class="row">
            <p class="sm-14 secondary-text intro-copy-text mt-4 text-center text-md-left">Select the currency, amount, and method for sending money. We’ll show you the exchange rate and total fees upfront.</p>
          </div>
        </div>
      </div>
      
      <div class="benefit-3">
        <div class="benefit-header text-center text-md-left">
          <div class="text-block-23">3</div>
        </div>
        <div class="benefit-text">
          <div class="text-block-22 text-center text-md-left">Input receiver details </div>
          <div class="row">
            <p class="sm-14 secondary-text intro-copy-text mt-4 text-center text-md-left">Tell us the details of the person receiving the money. Make sure it matches their identification documents exactly. </p>
          </div>
        </div>
      </div>
      <div class="benefit-4">
        <div class="benefit-header text-center text-md-left">
          <div class="text-block-23">4</div>
        </div>
        <div class="benefit-text">
          <div class="text-block-22 text-center text-md-left">Confirm and send</div>
          <div class="row">
            <p class="sm-14 secondary-text intro-copy-text mt-4 text-center text-md-left">Verify and double check everything is correct and send your money. That’s it! We’ll take care of the rest and tell you when money is transferred.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="about-section d-flex align-items-center" style="min-height: 650px;padding-bottom: 200px;">
  <div class="container-5 w-container">
    <div>
      <div class="about-header-panel"><img alt="About us" src="assets/images_new/logo_white.png" loading="lazy" width="42" height="42" alt="n2xpress - Send money across borders, the easy way.">
        <div class="section-header-text">About us</div>
      </div>
    </div>
    <div class="div-block-4">
      <div class="div-block-6">
        <p class="about-paragraph-left text-white">We all have ties to different places, leaving footprints of love and assets of affection. No matter where we go, those relationships are never lost but today&#x27;s money transfer services certainly don’t make it easy to stay connected.</p>
      </div>
      <div class="div-block-5">
        <p class="about-paragraph-right text-white">N2Xpress is changing that for good by making money transfers better for everyone around the world. As a high technology player with strategic partnerships, we make money meaningful for people living in between countries, so they can save more and do more.</p>
      </div>
    </div>
  </div>
</div>
<div>
  <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto my-5 rasputin">
      Sign up 
      <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
  </a>
</div>
<div class="testimonial-section pt-0">
  
  <div class="w-container text-center">
    <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
    <div class="testimonial-header">
      
      <div class="section-header-text testimonial">What our <br />customers say</div>
    </div>
    
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="slide-content">
            <div class="text-block-2">“N2Xpress made delivery of essentials for my mom on her birthday a reality. Wonderful service, will definitely use it again.”</div><img src="assets/images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="assets/images/Person-p-500.png 500w, assets/images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
            <div class="text-block-3">Dayo O.</div>
            <div class="text-block-4">Canada</div>
          </div>
          <!-- <img class="d-block w-100" src="..." alt="First slide"> -->
        </div>
        <div class="carousel-item">
          <div class="slide-content">
            <div class="text-block-2">&quot;This is a very interesting concept. I wish you plenty of success on this. I’ll definitely use it again.&quot;</div><img src="assets/images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="assets/images/Person-p-500.png 500w, assets/images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
            <div class="text-block-3">Femi A.</div>
            <div class="text-block-4">Canada</div>
          </div>
          <!-- <img class="d-block w-100" src="..." alt="Second slide"> -->
        </div>
        <div class="carousel-item">
          <div class="slide-content">
            <div class="text-block-2">&quot;This unique initiative of giving a platform to order for loved ones back home, sure deserves applause.&quot;</div><img src="assets/images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="assets/images/Person-p-500.png 500w, assets/images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
            <div class="text-block-3"><strong>Ayodeji Ilayasu</strong></div>
            <div class="text-block-4">United States</div>
          </div>
        </div>
        <div class="carousel-item">
          <div class="slide-content">
            <div class="text-block-2">&quot;I ordered recently for my family in Nigeria. Shout out to N2Xpress for remarkable service delivery.&quot;</div><img src="assets/images/Person.png" loading="lazy" width="50" sizes="100vw" srcset="assets/images/Person-p-500.png 500w, assets/images/Person.png 710w" alt="n2xpress - Send money across borders, the easy way." class="testimonial-image">
            <div class="text-block-3">Kelechi Igboegwu</div>
            <div class="text-block-4">United States</div>
          </div>
        </div>
      </div>
      <!-- <a class="carousel-control-prev text-dark" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="w-icon-slider-left fa-3x fa-indicators" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class=" w-icon-slider-right fa-indicators fa-3x" style="color:ff0054;" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a> -->
    </div>
  </div>
</div>
<app-home-footer></app-home-footer>


<style>
  .accordion-item-trigger .accordion-icon{
    transition: all 0.2s ease-out; 
  }
  .accordion-item-trigger + .accordion-item-content{
    transition: all 0.2s ease-out; 
  }
  .fa-indicators{
    color:#ff0054;
    background: none;
  }
</style>  